






























































import { computed, defineComponent, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import historyManager from "@/lib/historyManager";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BasePage from "@/components/BasePage";
import FiltersCreatorModal from "@/components/FiltersCreatorModal";
import PageTitle from "@/components/PageTitle";
import SuggestedCreators from "@/components/SuggestedCreators";
import CreatorsList from "./components/CreatorsList";
import usersAllController from "./controllers/usersAllController";
import usersSearchController from "./controllers/usersSearchController";
import { CreatorsTabsEnum } from "./types";

export default defineComponent({
  name: "PageCreatorsList",
  components: {
    SuggestedCreators,
    FiltersCreatorModal,
    BasePage,
    PageTitle,
    BaseIcon,
    BaseInput,
    CreatorsList,
  },
  props: {
    tab: { type: String as () => CreatorsTabsEnum, default: CreatorsTabsEnum.ALL },
  },
  setup() {
    const loading = ref(false);
    const showSelectTags = ref(false);
    const selectedTags = ref<TagInfo[]>([]);
    const allowSearch = computed(() => config.featureSearchBar);
    const showFilterBtn = computed(() => config.featureSearchBar && config.featureHashtags);
    const searchValue = ref("");
    const languages = ref<string[]>([]);
    const locations = ref<UserLocation[]>([]);
    const searchMode = computed(
      () =>
        !!searchValue.value || selectedTags.value.length > 0 || locations.value.length > 0 || languages.value.length > 0
    );
    const hasHistory = computed(() => historyManager.hasHistory());
    const selectedTagsIds = computed(() => selectedTags.value.map(tag => tag.id));
    const controller = computed(() => (searchMode.value ? usersSearchController : usersAllController));

    const onInputSearch = (value: string = "") => {
      searchValue.value = value;
    };

    const selectLanguages = (value: string[]) => {
      showSelectTags.value = false;
      languages.value = value;
    };

    const selectLocations = (value: UserLocation[]) => {
      showSelectTags.value = false;
      locations.value = value;
    };

    const onTagsSelect = (tags: TagInfo[]) => {
      showSelectTags.value = false;
      selectedTags.value = tags;
    };

    return {
      loading,
      allowSearch,
      searchValue,
      searchMode,
      hasHistory,
      controller,
      showSelectTags,
      selectedTags,
      showFilterBtn,
      TagInfoType,
      selectedTagsIds,
      languages,
      locations,
      onTagsSelect,
      onInputSearch,
      selectLanguages,
      selectLocations,
    };
  },
});
